<template>
  <div class="wework_choose_city">
    <div class="wework_choose_search">
      <van-search class="choose_search" v-model="searchObj.name" shape="round" placeholder="输入城市名或拼音查询" @input="handleSearch" />
    </div>
    <div class="wework_choose_scroll" v-if="cityList.length">
      <!-- 我的位置  -->
      <div v-if="cityName">
        <div class='list-horizontal myaddress'>
          <div class='myaddressText' @click='handleMyCity'>
            {{cityName}}
          </div>
          <div class="mt14">GPS定位</div>
        </div>
      </div>
      <div v-else>
        <div class='list-horizontal myaddress'>
          <div class='myaddressText' style="color: red; font-size: 15px" @click='position'>
            重新定位
          </div>
        </div>
      </div>
      <van-index-bar class="choose_bar" :index-list="indexList" :sticky-offset-top="50">
        <div v-for="(item,index) in cityList" :key="index">
          <van-index-anchor class="cell_title" :index="indexList[index]">{{item.indexCharacter}}</van-index-anchor>
          <div :class="`cell_` + index">
            <van-cell :title="v.cityName" v-for="(v,k) in item.cityCodeResultList" :key="k" @click="handleChoose(v)" />
          </div>
          <div style="height: 10px; background: #f7f7f7;" v-if="index === 0"></div>
        </div>
      </van-index-bar>
    </div>
    <div class="noData" v-else>没有搜索到相关的数据哦</div>
  </div>
</template>

<script>
export default {
  name: 'wework_choose_city',
  data() {
    return {
      searchObj: {
        name: ''
      },
      cityCode: '',
      cityName: '',
      indexList: [],
      all_cityList: [],
      cityList: []
    }
  },
  created() {
    const queryParams = this.$route.query
    console.log('queryParams', queryParams)
    if (queryParams.cityCode && queryParams.cityName) {
      this.cityCode = queryParams.cityCode
      this.cityName = queryParams.cityName
    }
    this.getCityQueryList()
  },
  mounted() {},
  methods: {
    handleChoose(v) {
      this.$router.push({
        name: 'wework_activity',
        query: {
          merchantId: this.$route.query.merchantId,
          cityCode: v.cityCode,
          cityName: v.cityName
        }
      })
    },
    handleSearch(v) {
      this.getCityByName(v)
    },
    handleMyCity() {
      this.$router.push({
        name: 'wework_activity',
        query: {
          merchantId: this.$route.query.merchantId,
          cityCode: this.cityCode,
          cityName: this.cityName
        }
      })
    },
    position() {
      this.$toast({ content: '请确认系统GPS功能或微信定位授权是否开启' })
    },
    // 根据输入过滤城市
    getCityByName(name) {
      if (name) {
        this.cityList = this.all_cityList
          .map((item) => {
            return {
              indexCharacter: item.indexCharacter,
              cityCodeResultList: item.cityCodeResultList.filter(
                (v) => v.cityName.indexOf(name) > -1
              )
            }
          })
          .filter((sub) => sub.cityCodeResultList.length)
        console.log('查询结果', this.cityList)
      } else {
        this.cityList = this.all_cityList
      }
      this.getRightArr(this.cityList)
    },
    // 根据城市列表获取右侧导航栏
    getRightArr(arr) {
      this.indexList = arr.map((i) =>
        i.indexCharacter === '国内热门城市' ? '热门' : i.indexCharacter
      )
    },
    getCityQueryList() {
      this.API.cityQueryList({
        merchantId: this.$route.query.merchantId
      })
        .then((res) => {
          if (res.status === 200) {
            const result = res.data || {}
            const hotCity = {
              cityCodeResultList: result.hotCityList || [],
              indexCharacter: '国内热门城市'
            }
            const cityList = []
            cityList.push(hotCity, ...result.cityManageResult)
            this.all_cityList = cityList
            this.cityList = cityList
            this.getRightArr(this.cityList)
            // console.log('城市列表', this.cityList)
          } else {
            this.$toast({ content: res.error })
          }
        })
        .catch((err) => {
          this.$toast({ content: err.error || '数据拉取失败' })
        })
    }
  }
}
</script>

<style lang="less" scoped>
.wework_choose_city {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .wework_choose_search {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    z-index: 20;
    background: #f7f8fa;
    .choose_search {
      width: 330px;
      height: 35px;
      border-radius: 45px;
      font-size: 14px;
      padding: 0px 15px;
      margin: 8px auto;
      background: #fff;
    }
    .van-search {
      background: #f7f8fa;
    }
    .van-search__content {
      background: #fff;
    }
  }
  .wework_choose_scroll {
    background: #fff;
    padding-top: 50px;
  }
  .list-horizontal {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 30px;
    padding-right: 50px;
    align-items: center;
  }

  .list-horizontal .list-name {
    border: 1px #e7e7e7 solid;
    border-radius: 5px;
    margin-right: 3%;
    width: 29%;
    text-align: center;
    padding: 15px 0;
    margin-bottom: 25px;
    font-size: 30px;
    color: #333;
    position: static;
  }
  .myaddress {
    padding: 10px 0;
    margin-left: 15px;
    border-bottom: 1px solid #eaeaea;
    font-size: 15px;
    color: #999;
  }
  .myaddressText {
    font-size: 18px;
    color: #000;
    margin-right: 8px;
  }
  .cell_0 {
    display: flex;
    flex-wrap: wrap;
    padding: 5px 15px;
    padding-right: 25px;
    align-items: center;
    .van-cell {
      border: 1px #e7e7e7 solid;
      border-radius: 2px;
      margin-right: 3%;
      width: 29%;
      text-align: center;
      padding: 7px 0;
      margin-bottom: 12px;
      font-size: 14px;
      color: #333;
      position: static;
    }
  }
  .mt14 {
    font-size: 13px;
  }
  .cell_title {
    /deep/.van-index-anchor {
      color: #999;
    }
  }
  /deep/.van-index-bar__index {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1px 5px;
    font-size: 12px;
    color: #666;
  }
  .noData {
    padding-top: 100px;
    text-align: center;
    font-size: 16px;
    color: #ddd;
    height: 100vh;
    background-color: #f5f7fc;
  }
}
</style>
